import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { LayoutPlugin } from 'bootstrap-vue'
import VueScrollmagic from 'vue-scrollmagic'
import VueI18n from 'vue-i18n'
import VueSmoothScroll from 'vue2-smooth-scroll'

Vue.use(LayoutPlugin)
Vue.use(VueScrollmagic)
Vue.use(VueI18n)
Vue.use(VueSmoothScroll, {
  duration: 800,       // animation duration in ms
  offset: -30,           // offset in px from scroll element, can be positive or negative
  updateHistory: true,  // whether to push hash to history
})

const i18n = new VueI18n({
  locale: 'default', // set locale
})

// import BootstrapVue from 'bootstrap-vue'
// Vue.use(BootstrapVue)

Vue.config.productionTip = false

new Vue({
  i18n,
  router, 
  render: h => h(App),
}).$mount('#app')
